import { render, staticRenderFns } from "./LoginRight.vue?vue&type=template&id=61d012b6&scoped=true"
import script from "./LoginRight.vue?vue&type=script&lang=js"
export * from "./LoginRight.vue?vue&type=script&lang=js"
import style0 from "./LoginRight.vue?vue&type=style&index=0&id=61d012b6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61d012b6",
  null
  
)

export default component.exports